import { Injectable, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";

import { Store } from "@ngrx/store";
import { CookieService } from "ngx-cookie-service";
import { mergeMap, tap } from "rxjs";
import { REQUEST_USER_ADDRESSES, SET_ACTIVE_USER_ADDRESS } from "../main/my-account/store/constants/constants";
import { SET_USER_ADDRESSES_ACTION } from "../main/my-account/store/profile.actions";
import { CHECK_VOUCHER } from "../main/products/store/constants/products.constant";
import { SET_VOUCHER_ACTION, SET_VOUCHER_PERCENTAGE_ACTION, SET_CART_TOTAL_WITH_VOUCHER_ACTION, CHECK_VOUCHER_ACTION, set_voucher_data_action } from "../main/products/store/products.action";
import { AppService } from "../Services/AppService/app.service";
import { PaymentService } from "../Services/PaymentService/payment.service";
import { MyAccountService } from "../Services/ProfileService/my-account.service";
import {  GET_CATEGORIES, get_paymob_iframe,GET_USER_WALLETS, GetBrandsData, GetCategoriesata, GetHotDealsData, GetSliders, GetSubCategories, remove_from_cart, request_add_to_cart, requist_cart_total, set_active_location, set_cart, set_delivery_type, SIGN_IN, SIGN_OUT } from "./constants/app.constant";
import { NzMessageService } from "ng-zorro-antd/message";
import { FETCH_CART_ACTION } from "projects/imakeapp-cart/src/lib/Domain/Facades/store/cart.action";
import { BrandsLoaded, CATEGORIES_LOADED_ACTION, CategoriesLoaded, HotDealsDataLoaded, SET_ORDER_TAX_DELIEVERY_ACTION, SET_USER_WALLETS_ACTION, SlidersLoaded, SubCategoriesLoaded } from "./app.action";
import { LanguageService ,LanguagePipe} from "imakeapp-shared";
import { MessageService } from "primeng/api";






@Injectable()
export class AppEffects implements OnInit
{




  constructor(
    private store:Store,
    private actions$: Actions,
    private service: AppService,
    private cookie_s: CookieService,
    private router: Router,
    private payment_s: PaymentService,
    private account_s: MyAccountService,
    private message: NzMessageService,
    private language_s: LanguageService,
    private language_p: LanguagePipe,
    private message_s: MessageService
  ) {}
  ngOnInit(): void {
  }





  get_categories$ = createEffect(
    () => {

      return this.actions$.pipe(
            ofType(GET_CATEGORIES),
            tap(
              (action: any)=>{

                this.service.get_categories().subscribe(
                (response: any)=>{

                  // this.store.dispatch(new CATEGORIES_LOADED_ACTION(response.data.categories));
                  this.store.dispatch(new CATEGORIES_LOADED_ACTION(response.data.subCategories));

                },
                (err: any)=>{
                  console.error(err);
                })

              }
            )
          )
  },{dispatch:false});


  sign_in_effect$ = createEffect(
  () => {

    return this.actions$.pipe(
          ofType(SIGN_IN),
          tap(
            (action:any)=>{

              // save in cookie
              this.cookie_s.set("user", JSON.stringify(action.data), undefined, '/');

              // fetch new cart (cart items connected to user id)
              this.store.dispatch(new FETCH_CART_ACTION());

            }
          )
        )
  },{dispatch:false});


  sign_out_effect$ = createEffect(
    () => {

      return this.actions$.pipe(
            ofType(SIGN_OUT),
            tap(
              (action:any)=>{

                // delete user
                this.cookie_s.delete("user", '/');

                // redirect to profile page
                this.router.navigateByUrl('/');


                // success
                let success_msg = {
                  header: this.language_p.transform('success_msg_title', 'header'),
                  body: this.language_p.transform('auth_modal_sign_out_success_message', 'header')
                };

                this.message_s.add({severity:'success', summary: success_msg.header, detail: success_msg.body });

                // fetch new cart (cart items connected to user id)
                this.store.dispatch(new FETCH_CART_ACTION());

              }
            )
          )
  },{dispatch:false});


  set_active_location_effect$ = createEffect(
    () => {

      return this.actions$.pipe(
            ofType(set_active_location),
            tap(
              (action:any)=>{

                // save in cookie
                this.cookie_s.set("location", JSON.stringify(action.data) , undefined, '/');

              }
            )
          )
  },{dispatch:false});




  check_voucher_effect$ = createEffect(
    () => {

      return this.actions$.pipe(
        ofType(CHECK_VOUCHER),
        tap(
          (action:any)=>{

            this.payment_s.check_voucher(action.data).subscribe(
              (response: any)=>{

                // save voucher data
                this.store.dispatch( new SET_VOUCHER_ACTION(action.data.code) );
                this.store.dispatch( new set_voucher_data_action(response) );
                this.store.dispatch( new SET_VOUCHER_PERCENTAGE_ACTION(response.percentage) );
                this.store.dispatch( new SET_CART_TOTAL_WITH_VOUCHER_ACTION(response.newTotal) );

              },
              (err)=>{

                // reset voucher data
                this.store.dispatch( new SET_VOUCHER_ACTION('') );
                this.store.dispatch( new SET_VOUCHER_PERCENTAGE_ACTION(0) );
                this.store.dispatch( new SET_CART_TOTAL_WITH_VOUCHER_ACTION(0) );

                let message = this.language_p.transform('order_invalid_coupon_message', "checkout");

                this.message.error(message, { nzDuration: 3000 , nzAnimate: true });

              }
            );

          }
        )
    )
  },{dispatch:false});





  get_user_addresses_effect$ = createEffect(
    () => {
      return this.actions$.pipe(
              ofType(REQUEST_USER_ADDRESSES),
              tap(
                (action: any)=>{

                  this.account_s.get_user_addresses().subscribe(
                    (response: any)=>{

                      let new_response = typeof response === 'string' ? [] : response;

                      this.store.dispatch( new SET_USER_ADDRESSES_ACTION(new_response) );

                    },
                    (err)=>{
                      console.error(err);
                    }
                  );

                }
              )

          )
  },{dispatch:false});




  set_active_user_address_effect$ = createEffect(
    () => {
      return this.actions$.pipe(
              ofType(SET_ACTIVE_USER_ADDRESS),
              tap(
                (action: any)=>{

                  let cart_code = this.cookie_s.get('cart_code');

                  // only trigger this when in checkout
                  // after checkout cart code gets deleted and you cannot get new prices data(tax/delievery fee) without code
                  if ( cart_code )
                  {
                //    this.store.dispatch( new GET_TAX_AND_DELIEVERY_ACTION() );
                  }


                }
              )

          )
  },{dispatch:false});








  get_paymob_iframe_effect$ = createEffect(
    () => {
      return this.actions$.pipe(
              ofType(get_paymob_iframe),
              tap(
                (action: any)=>{

                  // redirect to paymob preparing page
                  this.router.navigateByUrl('/shopping/payment');

                }
              )

          )
  },{dispatch:false});


  set_delivery_type_effect$ = createEffect(
    () => {
      return this.actions$.pipe(
              ofType(set_delivery_type),
              tap(
                ()=>{

              //    this.store.dispatch( new GET_TAX_AND_DELIEVERY_ACTION() );

                }
              )

          )
  },{dispatch:false});





  get_user_wallets_effect$ = createEffect(
    () => {
      return this.actions$.pipe(
              ofType(GET_USER_WALLETS),
              tap(
                ()=>{

                  this.account_s.getWallets().subscribe((data: any) => {


                    this.store.dispatch( new SET_USER_WALLETS_ACTION(data) );



                  });

                }
              )

          )
  },{dispatch:false});




  getSlider$ = createEffect(
    () => {
      return this.actions$.pipe(
              ofType(GetSliders),
              tap(
                ()=>{
                  this.service.GetSlider().subscribe(
                  (response: any)=>{
                    this.store.dispatch(new SlidersLoaded(response.data))
                  },
                  (err: any)=>{
                    console.error(err);
                  })
                }
              )

          )
  },{dispatch:false});

  getSubCategories$ = createEffect(
      () => { return this.actions$
          .pipe(
              ofType(GetSubCategories),

              mergeMap(async action  => {
                    this.service.GetSubcategory().subscribe(
                      (response: any)=>{
                  this.store.dispatch(new SubCategoriesLoaded(response.data))
                },
                (err: any)=>{
                    console.error(err);
                })




              })

          )
          },{dispatch:false})


  getHotDealsData$ = createEffect(
      () => { return this.actions$
          .pipe(
              ofType(GetHotDealsData),

              mergeMap(async action  => {
                this.service.GetOffersData().subscribe(
                (response: any)=>{
                  this.store.dispatch(new HotDealsDataLoaded(response))
                },
                (err: any)=>{
                    console.error(err);
                }
                )




              })

          )
          },{dispatch:false})


  getCategories$ = createEffect(
  () => { return this.actions$
      .pipe(
        ofType(GetCategoriesata),

        mergeMap(async action  => {
              this.service.GetCategoriesData().subscribe(
              (response: any)=>{
              this.store.dispatch(new CategoriesLoaded(response.data))
          },
          (err: any)=>{
              console.error(err);
          })




        })

    )
    },{dispatch:false})







}


